import React, { Component } from 'react';
import { Button, Col, Input, Row, Select, Form, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import { VDS_REQUEST_TYPES } from '../../constants/vdsMessage';

const { RangePicker } = DatePicker;

class VDSMessagesFilterForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
  };

  formRef = React.createRef();

  onClear = () => {
    this.formRef.current?.resetFields();
    this.props.onFilter({});
  };

  onFinish = (values) => {
    this.props.onFilter(values);
  };

  render() {
    const { t } = this.props;

    return (
      <Form ref={this.formRef} layout="vertical" onFinish={this.onFinish}>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              label={t('filter.requestId')}
              name="requestId"
              hasFeedback={false}
              getValueFromEvent={(e) => {
                const v = e.target.value;
                return v === '' ? undefined : v;
              }}
            >
              <Input placeholder={t('filter.requestIdPlaceholder')} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={t('filter.registryCode')}
              name="registryCode"
              hasFeedback={false}
              getValueFromEvent={(e) => {
                const v = e.target.value;
                return v === '' ? undefined : v;
              }}
            >
              <Input placeholder={t('filter.registryCodePlaceholder')} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={t('filter.requestType')}
              name="requestType"
              hasFeedback={false}
            >
              <Select
                placeholder={t('filter.requestTypePlaceholder')}
                allowClear
              >
                {VDS_REQUEST_TYPES.map((type, idx) => (
                  <Select.Option key={idx} value={type}>
                    {t(`values.requestType_${type}`)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={t('filter.success')}
              name="success"
              hasFeedback={false}
            >
              <Select placeholder={t('filter.successPlaceholder')} allowClear>
                <Select.Option value="1">
                  {t('values.successYes')}
                </Select.Option>
                <Select.Option value="0">{t('values.successNo')}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={t('filter.requestDate')}
              name="requestDate"
              hasFeedback={false}
            >
              <RangePicker format="DD.MM.YYYY" />
            </Form.Item>
          </Col>
        </Row>
        <div className={'component-form-actions'}>
          <Button onClick={this.onClear}>{t('filter.clearBtn')}</Button>
          <Button type="primary" htmlType="submit">
            {t('filter.submitBtn')}
          </Button>
        </div>
      </Form>
    );
  }
}

const VDSMessagesFilter = VDSMessagesFilterForm;
export default VDSMessagesFilter;
